import React, { useState } from 'react';
import styles from './ResetPassword.module.css';
import NextButton from '../../components/NextButton/NextButton';
import LoginLeftSide from '../../components/LoginLeftSide/LoginLeftSide';


const ResetPassword = ({ onSubmit }) => {
  const [email, setEmail] = useState('');
  const [password, enterPassword] = useState('');
  const [reEnterpassword, confirmPassword] = useState('');

  const handlePWSubmit = (e) => {
    e.preventDefault();

    if (password == reEnterpassword) {
      onSubmit({ email, password });
      setEmail('');
      enterPassword('');
      confirmPassword('');
    } else {
      console.log("! Passwords do not match.")
      alert("Passwords did not match. ")
    }

  };

  return (
    <div className={styles.loginContainer}>
      <LoginLeftSide />

      <div className={styles.rightSide}>
        <div className={styles.formcontainer}>
          <div className={styles.title}>Reset Password</div>

          <form onSubmit={handlePWSubmit}>
            <label> Email: </label> <br />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.fieldinputs}
            />
            <br />

            <label> Enter new password: </label> <br />
            <input
              type="password"
              value={password}
              onChange={(e) => enterPassword(e.target.value)}
              required
              className={styles.fieldinputs}
            />
            <br />

            <label> Confirm password: </label> <br />
            <input
              type="password"
              value={reEnterpassword}
              onChange={(e) => confirmPassword(e.target.value)}
              required
              className={styles.fieldinputs}
            />
            <br />

            <NextButton />
          </form>
        </div>
      </div>
    </div>

  );
};

export default ResetPassword;